<!--
 * @Author: RYL
 * @Description:
 * @Date: 2020-10-28 16:25:25
 * @LastEditTime: 2021-01-04 11:03:08
-->
<template>
  <div>
    <el-form 
      :model="searchData" 
      ref="searchForm" 
      :inline="true" 
      label-width="100px" 
      label-position="right" 
      :rules="rules">
      <el-form-item label="项目名称：" prop="groupId">
        <project-trees style="margin-top: 8px; vertical-align: top" @clickProject="clickProject"></project-trees>
      </el-form-item>
      <el-form-item label="设备名称：" prop="deviceDid">
        <el-select size="mini" v-model="searchData.deviceDid" clearable>
          <el-option
            v-for="item in deviceList"
            :key="item.deviceDid"
            :label="`${item.deviceSn}（${item.deviceName ? item.deviceName : 'N/A'}）`"
            :value="item.deviceDid">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间：" prop="dateTime">
        <el-date-picker 
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          v-model="searchData.dateTime"
          size="mini">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" type="primary" >查询</el-button>  
      </el-form-item>
    </el-form>
    <div class="line-chart">
      <line-chart :autoresize="true" :options="lineOptions"></line-chart>
    </div>
  </div>
</template>
<script>
import { getFirstGroup, getSecondGroup } from '@/api/cloudMonitor/projectGroup'
import { getListByGroup } from '@/api/cloudMonitor/deviceList'
import projectTrees from '../../components/projectTrees'

import ECharts from "vue-echarts";
import "echarts/lib/chart/line";
import "echarts/lib/component/polar";
import "echarts/lib/component/dataZoom";
export default {
  components: {
    lineChart: ECharts,
    projectTrees
  },
  data() {
    return {
      searchData: {
        groupId: '',
        deviceDid: '',
        dateTime:''
      },
      deviceList: [],
      props: {
        lazy: true,
        checkStrictly: true,
        leaf: 'leaf',
        lazyLoad: this.lazyLoad
      },
      rules: {
        groupId: [
          { required: true, message: '请选择项目分组', trigger: 'blur'}
        ],
        deviceDid: [
          { required: true, message: '请选择设备', trigger: 'blur'}
        ]
      },
      lineOptions: {}, // 折线图配置
    }
  },
  mounted() {
    this.initLineChart()
  },
  methods: {
     // 点击项目节点
    clickProject(node) {
      // 切换了之后，就重置所有数据
      let params = {
        pageParam: {
          current: 1,
          size: 99999
        },
        deviceInfo: {
          deviceGid: node.groupId
        }
      }
      // 获取设备列表
      getListByGroup(params).then(res => {
        if(res.data.code === 0) {
          let data = res.data.data
          this.deviceList = data.records
          if(this.deviceList.length > 0) {
            this.searchData.deviceDid = this.deviceList[0].deviceDid
            // 默认获取第一个设备的变量
            this.getDeviceParams()
          }
        }
      })
    },
    // 初始化折线图
    initLineChart() {
      this.lineOptions = {
        title: {
          text: '历史记录'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            animation: false,
          }
        },
        legend:{
          data: ['变量1', '变量2', '变量3']
        },
        dataZoom: [
          {
            show: true,
            realtime: true,
            start: 0,
            end: 20,
          }
        ],
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['时间1', '时间2', '时间3','时间1', '时间2', '时间3','时间1', '时间2', '时间3','时间1', '时间2', '时间3']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '变量1',
            type: 'line',
            data: [1, 10, 40,1, 10, 40,1, 10, 40,1, 10, 40,]
          },
          {
            name: '变量2',
            type: 'line',
            data: [10, 30, 40,10, 30, 40,10, 30, 40,10, 30, 40]
          },
          {
            name: '变量3',
            type: 'line',
            data: [3, 30, 40,10, 30, 40,10, 30, 40,10, 30, 40]
          },
        ]
      }
    },
    // 选择项目后显示对应的设备
    projectChange(val) {
      console.log('val');
      console.log(val[val.length - 1]);
      let params = {
        pageParam: {
          current: 1,
          size: 99999
        },
        deviceInfo: {
          deviceGid: val[val.length - 1]
        }
      }
      getListByGroup(params).then(res => {
        if(res.data.code === 0) {
          let data = res.data.data
          this.deviceList = data.records
        }
      })
    }
  }
}
</script>
<style scoped>
.line-chart{
  width: 100%;
  height: 70vh;
}
.echarts {
  width: 100%;
  height: 100%;
  margin-top: 20px;
}
</style>